<script>
export default {
  name: 'PageScrollerTwoButtons',
  methods: {
    scroll(isVectorUp) {
      const top = isVectorUp ? 0 : document.documentElement.scrollHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    },
  },
};
</script>

<template lang="pug">
  .b-buttons
    ._scroller(@click="scroll(true)")
      Icon._icon(name="arr-scroll" :class="{ up: true }" pointer)
    ._scroller(@click="scroll(false)")
      Icon._icon(name="arr-scroll" pointer)
</template>

<style scoped lang="scss">
.buttons {
  position: fixed;
  bottom: 100px;
  left: calc(10vw - 100px);
  z-index: 1010;
  display: flex;
  flex-direction: column;
  gap: 25px;

  &__scroller {
    width: 48px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .up {
      rotate: 180deg;
    }
  }

  @media (max-width: 1700px) {
    left: 48px;
  }

  @media (max-width: 1500px) {
    bottom: 180px;
  }

  @media (max-width: 1024px) {
    display: none;
  }
}
</style>
